/**
 * Câu nói THẬT với người đứng quầy sau khi tiệm huỷ / từ chối / đổi giờ một lịch: khách được báo bằng cách nào
 * (K1a, docs/plans/k1-bao-khach-khi-tiem-huy-doi-gio.md 5). Máy chủ trả MỘT nhãn; quầy không tự suy ra.
 * Máy chủ bản cũ không trả nhãn → không hứa gì.
 */
import { T } from './text/vi.ts'

export type BaoKhach = 'trong-app' | 'goi-khach' | 'khong-khach' | 'zalo' | 'chua-co-so'

export function cauBaoKhach(b: BaoKhach | null | undefined): string | null {
  switch (b) {
    case 'zalo':
      return T.baoKhachZalo
    case 'trong-app':
      return T.baoKhachTrongApp
    case 'goi-khach':
      return T.baoKhachGoi
    case 'chua-co-so':
      return T.baoKhachChuaSo
    default:
      return null
  }
}

/** Toast của quầy: câu + nhãn khách được báo (để biết toast là "xong" hay "bạn còn việc phải làm"). */
export type ToastQuay = { chu: string; baoKhach?: BaoKhach | null | undefined }

/** Chủ tiệm còn phải LÀM TIẾP (gọi / nhắn khách) — khác với việc đã xong. */
function canLamTiep(b: BaoKhach | null | undefined): boolean {
  return b === 'goi-khach' || b === 'chua-co-so'
}

/** Cần làm tiếp -> cảnh báo (vàng); đã xong -> thành công (xanh). Dùng lớp `canh-bao` có sẵn. */
export function kieuToast(b: BaoKhach | null | undefined): 'canh-bao' | 'thanh-cong' {
  return canLamTiep(b) ? 'canh-bao' : 'thanh-cong'
}

/** Cần làm tiếp -> giữ ít nhất 10 giây (đọc xong còn kịp cầm máy gọi); còn lại giữ hạn mặc định. */
export function hanToastMs(b: BaoKhach | null | undefined, macDinhMs: number): number {
  return canLamTiep(b) ? Math.max(10000, macDinhMs) : macDinhMs
}

function ghep(viec: string, b: BaoKhach | null | undefined): string {
  const cau = cauBaoKhach(b)
  return cau === null ? viec : `${viec}. ${cau}`
}

/** Toast sau khi dời lịch ("Đã dời lịch của Lan. Khách thấy tin khi …"). */
export function toastSauDoi(ten: string, b: BaoKhach | null | undefined): string {
  return ghep(T.movedToast(ten), b)
}

export function toastSauHuy(ten: string, b: BaoKhach | null | undefined): string {
  return ghep(T.daHuyToast(ten), b)
}

export function toastSauTuChoi(ten: string, b: BaoKhach | null | undefined): string {
  return ghep(T.daTuChoiToast(ten), b)
}
